import { render, staticRenderFns } from "./EditWhoModal.vue?vue&type=template&id=56e1b126&"
import script from "./EditWhoModal.vue?vue&type=script&lang=js&"
export * from "./EditWhoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56e1b126')) {
      api.createRecord('56e1b126', component.options)
    } else {
      api.reload('56e1b126', component.options)
    }
    module.hot.accept("./EditWhoModal.vue?vue&type=template&id=56e1b126&", function () {
      api.rerender('56e1b126', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/EditWhoModal.vue"
export default component.exports